module.exports = __webpack_public_path__ + "static/media/RA_V1.d6d48e2c.gif";